import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

import stepIcon from '../../../theme/assets/other/tc_cab_apostol_step_icon.png';
import arrowIcon from '../../../theme/assets/svg/tc_cab_apostol_arrow_icon.svg';

const CabinetApostolHow = () => {
    const { t } = useTranslation();

    const steps = [
        {
            title: t('Приглашайте ваших друзей'),
            description: t('Делитесь своей ссылкой и расширяйте сеть')
        },
        {
            title: t('Развивайте структуру'),
            description: t('Активные рефералы повышают уровень ковчегов')
        },
        {
            title: t('Получайте вознаграждения'),
            description: t('Зарабатывайте $TC за активность вашей сети')
        },
        {
            title: t('Выводите и используйте'),
            description: t('Выводите токены или реинвестируйте в проект')
        }
    ];

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardTitle}`}>{t('Как это работает?')}</div>
                    <div className={`${Styles.stepsWrap}`}>
                        {steps.map((item, index) => {
                            return (
                                <React.Fragment key={'apostol-step_' + index}>
                                    {index > 0 ? (
                                        <div className={`${Styles.stepArrow}`}>
                                            <img src={arrowIcon} alt=""/>
                                        </div>
                                    ) : null}
                                    <div className={`${Styles.stepItem}`}>
                                        <div className={`${Styles.stepIconWrap}`}>
                                            <img src={stepIcon} alt=""/>
                                        </div>
                                        <div className={`${Styles.stepTitle}`}>{item.title}</div>
                                        <div className={`${Styles.stepNote}`}>{item.description}</div>
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetApostolHow;
